import Webphone from 'common/Webphone'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const useBeforeUnloadPrompt = () => {
    const { calls } = useSelector((state) => state.call)

    // Add onbeforeunload prompt window and finish all calls on onunload event
    useEffect(() => {
        const beforeunloadHandler = (e) => {
            e.preventDefault()
            const message = 'Are you sure to refresh the page? If you do it, it will end all your activities'
            e.returnValue = message
            return message
        }

        const unloadHandler = () => {
            calls.forEach((call) => call?.number && Webphone.hangup(call.number))
        }

        const addListeners = () => {
            window.addEventListener('beforeunload', beforeunloadHandler)
            window.addEventListener('unload', unloadHandler)
        }

        const removeListeners = () => {
            window.removeEventListener('beforeunload', beforeunloadHandler)
            window.removeEventListener('unload', unloadHandler)
        }

        calls.length ? addListeners() : removeListeners()

        return removeListeners
    }, [calls])
}
